var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('C1Button',{staticClass:"af-btn-quick-apply afu-truncate",attrs:{"type":"button","variant":"neutral","size":"sm"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.applyNow()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }